import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import styles from './emailSetup.scss'
import nesProp from 'nested-property'
import CustomSelect from './officeHelper'
import i18n from 'lib/i18n'
import {fetchOfficeData, loadEmailServer, saveEmailServer, deleteEmailServer, sendTestEmailWithConfig} from '../../state/actions'
import cs from 'classnames'
import moment from 'moment'
import Modal from 'react-modal'
import TestEmailDialog from './testEmailDialog'
import AreYouSureDialog from './areYouSureModal'

const _ = i18n('office')

@connect(state => ({
    brokers: nesProp.get(state, "office.brokers"),
    accountManagers: nesProp.get(state, "office.accountManagers"),
    userId: nesProp.get(state, "app.userId")
}))
export default class EmailSetup extends React.Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        let brokerOptions = this.getEmailsInOptionList()

        let formInitialValues = this.getFormInitialValues()
        let fields = this.formInputFieldsList(formInitialValues)

        this.state = {
            configsLoaded: null,
            isLoaded: true,
            brokerOptions: brokerOptions,
            fields,
            saved: false,
            isOpenTestMailModal: false,
            isOpenAreYouSureModal: false,
            onSendError: null
        }
    }

    /**
     * Component did mount hook. Check and load all the dependency values, init related values.
     */
    componentDidMount() {
        this.initPage()
    }

    /**
     * Load values and process it
     */
    initPage() {
        const {dispatch} = this.props
        const {brokerOptions, fields, configsLoaded} = this.state
        let emailAddress = nesProp.get(fields, "emailAddress.value")

        this.setState({isLoaded: false})

        // load every dependency data if necessary
        let allNecessaryDataLoaderPromise = []

        // LOAD BROKERS
        let brokerLoader = new Promise((resolve, reject) => {
            if (!brokerOptions || brokerOptions.length === 0) {
                // must get the office data for all informations for variables
                dispatch(fetchOfficeData()).then(() => {
                    let brokerOptions = this.getEmailsInOptionList()
                    this.setState({brokerOptions}, () => {
                        resolve()
                    })
                })
                .catch((err)=>{
                    console.log("ERRRRROR brokerLoader ", err)
                    reject(err)
                })
            } else {
                resolve()
            }
        })

        allNecessaryDataLoaderPromise.push(brokerLoader)

        // LOAD CONFIG
        let configLoader = new Promise((resolve, reject) => {

            if (!emailAddress) {
                return resolve({})
            }

            if (!configsLoaded || configsLoaded.emailAddress !== emailAddress) {
                dispatch(loadEmailServer(emailAddress))
                .then((configsResult) => {
                    this.setState({configsLoaded: configsResult}, ()=>{
                        resolve()
                    })
                }).catch((err)=>{
                    console.log("ERRRRROR load configs fro broker ", err)
                    reject(err)
                })

            } else {
                if (!this.state.clientOptionsDict) {
                    this.setState({clientOptionsDict: dictionary}, ()=>{
                        resolve()
                    })
                } else {
                    resolve()
                }
            }
        })

        allNecessaryDataLoaderPromise.push(configLoader)

        // promiseAll and set a flag to enable rendering of the module
        return Promise.all(allNecessaryDataLoaderPromise)
        .then(() => {
            // re-init the "Step 1" form inputs, and values
            let formInitialValues = this.getFormInitialValues()
            let fields = this.formInputFieldsList(formInitialValues)

            this.setState({fields}, () => {

                this.setState({isLoaded: true})
                // reset the flag of form validity
                this.setFormValidityFlag()
            })
        })
        .catch((err) => {
            this.setState({isLoaded: true})
            console.log("Something goes wrong on init: ", err)
        })
    }

    /**
     * This function will set state for the broker selector input.
     * Insert the list of broker like an array contains plain JS objects (label, value).
     */
    getEmailsInOptionList() {
        const {brokers, userId} = this.props
        const brokerObjKeys = brokers && Object.keys(brokers) || []

        let emailList = []

        // broker own email adddresses fetch from deep
        brokerObjKeys.forEach((brokerKey) => {
            if (brokers[brokerKey].main.emails) {
                brokers[brokerKey].main.emails.forEach((oneEmail) => {
                    emailList.push({
                        value: oneEmail,
                        label: oneEmail
                    })
                })
            }
        })

        let firstBrokerStaffList = brokers[brokerObjKeys[0]].staff
        if (firstBrokerStaffList && firstBrokerStaffList.length > 0) {
            firstBrokerStaffList.forEach((oneStaff)=>{
                if (oneStaff.userId == userId) {
                    emailList.push({
                        value: oneStaff.email,
                        label: oneStaff.email
                    })
                }
            })
        }

       // filtering duplicated email addresses
       let result = [], helperAlreadyInserteds = []
       if ( emailList && emailList.length > 0 ) {
            emailList.forEach((val, index)=>{
               if (helperAlreadyInserteds.indexOf(val.value) === -1) {
                   result.push({ value: val.value, label: val.label })
                   helperAlreadyInserteds.push(val.value)
               }
           })
       }


        // add from auth the account managers emails
        /* const accManagerObjKeys = accountManagers && Object.keys(accountManagers) || []
        accManagerObjKeys.forEach((managerKey) => {
            emailList.push({
                value: accountManagers[managerKey].email,
                label: accountManagers[managerKey].email + " - " + accountManagers[managerKey].Name
            })
        }) */

        return result
    }

    findItemByValueFromSelectOptions(value, options) {
        let result = {label: value, value: value}

        if (!options) {
            return  result
        }

        let filteredByValue = options.filter((item)=>{
            return item.value === value
        })

        // if no result in list of options the result the subject value
        if (!filteredByValue || filteredByValue.length === 0) {
            return result
        }

        // in case of match then the first match is the selected one. If there are no values then remains the subject value
        return nesProp.get(filteredByValue, "0") || result
    }

    /**
     * One input field basic props for handle form.
     */
    _inputPrototype() {
        return {type: "text", label: "", value: "", touched: false, error: false, isRequired: false, isValid: ()=>(true), errorMessage: _("invalidInputValue")}
    }

    /**
     * Copy one input handler object and return.
     */
    _initValueOfInput () {
        let proto = JSON.parse(JSON.stringify(this._inputPrototype()))
            proto.isValid = ()=>(true) // JSON trick is not perfect to copy an object :)
        return proto
    }

    /**
     * This function prepare and return a bunch of predefined data for the form inputs indexed by form input ref names
     */
    getFormInitialValues() {
        let brokerOptions = this.getEmailsInOptionList()
        const configsInState = nesProp.get(this, "state.configsLoaded")
        // const fields = nesProp.get(this, "state.fields")

        let emailAddress = nesProp.get(configsInState, "emailAddress") || ""
        let senderName = nesProp.get(configsInState, "senderName") || ""
        // let host = nesProp.get(configsInState, "host") || ""
        // let port = nesProp.get(configsInState, "port") || ""
        // let secureConnection  = nesProp.get(configsInState, "secureConnection") || ""
        // let secure = nesProp.get(configsInState, "secure") || ""
        // let autotls = nesProp.get(configsInState, "autotls") || false
        // let tls_rejectUnauthorized  = nesProp.get(configsInState, "tls_rejectUnauthorized") || ""
        // let auth_user =  nesProp.get(configsInState, "auth_user") || ""
        // let auth_password = nesProp.get(configsInState, "auth_password") || ""
        // let service =  nesProp.get(configsInState, "service") || ""
        // let useBounce = nesProp.get(configsInState, "useBounce") || ""
        let active = true

        let initialValues = {
            emailAddress,
            senderName,
            // host,
            // port,
            // secureConnection,
            // secure,
            // autotls,
            // tls_rejectUnauthorized,
            // auth_user,
            // auth_password,
            // service,
           // useBounce,
            // active,
        }
        /* let initialValues = {
            emailAddress: nesProp.get(fields, "emailAddress.value") || emailAddress,
            host: nesProp.get(fields, "host.value") || host,
            port: nesProp.get(fields, "port.value") || port,
            secureConnection : nesProp.get(fields, "secureConnection.value") || secureConnection,
            secure: nesProp.get(fields, "secure.value") || secure,
            tls_rejectUnauthorized : nesProp.get(fields, "tls_rejectUnauthorized.value") || tls_rejectUnauthorized,
            auth_user:  nesProp.get(fields, "auth_user.value") || auth_user,
            auth_password: nesProp.get(fields, "auth_password.value") || auth_password,
            service:  nesProp.get(fields, "service.value") || service,
            active: nesProp.get(fields, "active.value") || active,
        } */

        return initialValues
    }

     /**
     * Compose and setup the form inputs with validation an custom error messages
     * @param {*} formInitialValues - initial values for the form.
     */
    formInputFieldsList (formInitialValues) {
        return {
            "emailAddress": {...(this._initValueOfInput()),
                isRequired: true,
                errorMessage: _("invalidEmailAddress"),
                value: nesProp.get(formInitialValues, "emailAddress"),
                type: "select"
            },

            "senderName": {...(this._initValueOfInput()),
                isRequired: true,
                errorMessage: _("invalidSenderName"),
                value: nesProp.get(formInitialValues, "senderName"),
                type: "text"
            },
            // "host": {...(this._initValueOfInput()),
            //     isRequired: true,
            //     errorMessage: _("invalidHost"),
            //     value: nesProp.get(formInitialValues, "host"),
            //     type: "text"
            // },
            // "port": {...(this._initValueOfInput()),
            //     isRequired: true,
            //     errorMessage: _("invalidPort"),
            //     isValid: (value) => { return (((value*1)+"") === (value+""))},
            //     value: nesProp.get(formInitialValues, "port"),
            //     type: "text"
            // },
            // "secureConnection": {...(this._initValueOfInput()),
            //     isRequired: false,
            //     errorMessage: _("invalidSecureConnection"),
            //     value: nesProp.get(formInitialValues, "secureConnection"),
            //     type: "checkbox"
            // },
            // "secure": {...(this._initValueOfInput()),
            //     isRequired: false,
            //     errorMessage: _("invalidSecure"),
            //     value: nesProp.get(formInitialValues, "secure"),
            //     type: "checkbox"
            // },
            // "autotls": {...(this._initValueOfInput()),
            //     isRequired: false,
            //     errorMessage: _("invalidAutotls"),
            //     value: nesProp.get(formInitialValues, "autotls"),
            //     type: "checkbox"
            // },
            // "tls_rejectUnauthorized": {...(this._initValueOfInput()),
            //     isRequired: false,
            //     errorMessage: _("invalidTls_rejectUnauthorized"),
            //     value: nesProp.get(formInitialValues, "tls_rejectUnauthorized"),
            //     type: "checkbox"
            // },
            // "auth_user": {...(this._initValueOfInput()),
            //     isRequired: true,
            //     errorMessage: _("invalidAuth_user"),
            //     value: nesProp.get(formInitialValues, "auth_user"),
            //     type: "text"
            // },
            // "auth_password": {...(this._initValueOfInput()),
            //     isRequired: true,
            //     errorMessage: _("invalidAuth_password"),
            //     value: nesProp.get(formInitialValues, "auth_password"),
            //     type: "text"
            // },
            // "service": {...(this._initValueOfInput()),
            //     isRequired: false,
            //     errorMessage: _("invalidService"),
            //     value: nesProp.get(formInitialValues, "service"),
            //     type: "text"
            // },
            // "useBounce": {...(this._initValueOfInput()),
            //     isRequired: false,
            //     errorMessage: _("invalidUseBounce"),
            //     value: nesProp.get(formInitialValues, "useBounce"),
            //     type: "checkbox"
            // },
            // "active": {...(this._initValueOfInput()),
            //     isRequired: false,
            //     errorMessage: _("invalidActive"),
            //     value: nesProp.get(formInitialValues, "active"),
            //     type: "checkbox"
            // },
        }
    }

    /**
     *
     */
    resetForm() {
        const {fields} = this.state
        let formInitialValues = this.getFormInitialValues()

        formInitialValues.emailAddress = fields.emailAddress.value

        let fieldsToSet = this.formInputFieldsList(formInitialValues)

        return new Promise((resolve)=>{
            this.setState({fields: fieldsToSet}, resolve)
        })
    }

    /**
     * This function validate one field from the form.
     * @param {*} formField - instance of input field object
     * @param {*} inputValue - the new value of input
     * @param {*} forceTouch - touch anyway the input even if the value is not modified (useful on onBluer fired or onSubmit)
     */
    fieldValidation (formField, forceTouch = false) {
        // required check
        if (formField.isRequired && !formField.value) {
            formField.error = _("fieldRequired")
            formField.touched = forceTouch ? true : formField.touched
        } else {
            // validate if "isValid" property is set
            if (formField.isValid) {
                if (formField.isValid(formField.value)) {
                    formField.error = false
                } else {
                    formField.error = formField.errorMessage
                    formField.touched = forceTouch ? true : formField.touched
                }
            } else {
                formField.error = false
                formField.touched = forceTouch ? true : formField.touched
            }
        }

        // reset the flag of form validity
        this.setFormValidityFlag()

        return formField
    }

    /**
     * Set all form input untouched
     */
    unTouchFields() {
        const fields = nesProp.get(this, "state.fields")
        const formInputNames = Object.keys(fields)
        formInputNames.forEach((formFieldName) => {
            let formField = nesProp.get(fields, formFieldName)
            formField.touched = false
            nesProp.set(fields, formFieldName, formField)
        })
        this.setState({fields: fields})
    }

    /**
     * Reset the flag of form validity in state by checking the formInputs in state.
     */
    setFormValidityFlag() {
        const fields = nesProp.get(this, "state.fields")

        // every change must set the valid form
        if (fields) {
            let hasError = false
            let keys = Object.keys(fields) || []

            keys.forEach((oneKey) => {
                if (fields[oneKey].error) {
                    hasError = true
                }
            })

            this.setState({isValidTheForm: (hasError ? false : true)})

            return hasError ? false : true
        }

        return true
    }

    /**
     * Validate the hole form.
     * @param {*} data
     * @param {*} formInputs
     *
     * @returns formInputs - reference to formInputs object in state
     */
    formInputsValidation (formInputs, forceTouch = false) {
        if (!formInputs) {
            return
        }

        const formInputNames = Object.keys(formInputs)
        formInputNames.forEach((formFieldName) => {

            let formField = nesProp.get(formInputs, formFieldName)

            formField = this.fieldValidation(formField, forceTouch)

            //senderName should not include @
            if(formField.isValid && formFieldName === 'senderName'){
                if(formField.isValid(formField.value)){
                    formField = this.validateSenderNameField(formField)
                }
            }

            // set back the value but this is already set by address, but must implement to see what happen
            // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
            nesProp.set(formInputs, formFieldName, formField)
        })

        // reset the flag of form validity
        this.setFormValidityFlag()

        return formInputs
    }

    /**
     * Fetch values from form by input refs
     */
    fetchFormValues() {
        const {fields} = this.state
        const formFieldNames = Object.keys(fields)
        let formData = {}

        formFieldNames.forEach((formFieldName) => {
            let formFieldValue

            switch(fields[formFieldName].type) {
                case 'select' : {
                    // react creatable select way to get value
                    formFieldValue = nesProp.get(this, "refs." + formFieldName + ".props.value.value")

                    // if not then react select way to get value
                    formFieldValue = formFieldValue || nesProp.get(this, "refs." + formFieldName + ".state.value.value")
                    break
                }
                case 'text' : {
                     // if not then normal text input way to get value
                    formFieldValue = formFieldValue || nesProp.get(this, "refs." + formFieldName + ".value")
                    break
                }
                case 'checkbox' : {
                     // if not then normal text input way to get value
                    formFieldValue = formFieldValue || nesProp.get(this, "refs." + formFieldName + ".checked")
                    break
                }
                default: {
                    formFieldValue = formFieldValue || nesProp.get(this, "refs." + formFieldName + ".value")
                }
            }

            formData[formFieldName] = (typeof formFieldValue === "string") ? String(formFieldValue).trim() : formFieldValue
        })

        return formData
    }

    /**
     * Change one input value in state, validate also.
     */
    onChangeFormInput(value, formFieldName, forceTouch = null) {
        const {fields} = this.state
        //const data = this.fetchFormValues()

        //get the object from state to be able to set the validity value in it.
        let formField = nesProp.get(fields, formFieldName)

        // handle touch input
        if (formField.value !== value && (forceTouch === null)) {
            formField.touched = true
        }

        if (forceTouch !== null) {
            formField.touched = forceTouch
        }

        // set the value
        formField.value = value

        // set the validity in object, this will be set because it passed by address in JS
        formField = this.fieldValidation(formField)

        //senderName should not include @
        if(formField.isValid && formFieldName === 'senderName'){
            if(formField.isValid(formField.value)){
                formField = this.validateSenderNameField(formField)
            }
        }

        // this wil set back the value but implemented only for to be understandable, the value is set by address of object.
        nesProp.set(fields, formFieldName, formField)

        // put back into the state
        this.setState({fields: fields})
    }

    /**
     * senderName should not include @
     * @param {*} formField
     * @returns
     */
    validateSenderNameField(formField){
        if(formField.value && formField.value.includes('@')){
            formField.error = _("invalidCharacter")
        }

        // reset the flag of form validity
        this.setFormValidityFlag()

        return formField
    }


    /**
     * Fill the form values in state
     * @param {*} data
     * @param {*} formInputs
     *
     * @returns formInputs - reference to formInputs object in state
     */
    setFormInputsByFormValues (data, formInputs) {
        if (!formInputs) {
            return
        }

        const formInputNames = Object.keys(formInputs)
        formInputNames.forEach((formFieldName) => {

            let dataField = nesProp.get(data, formFieldName)
            let formField = nesProp.get(formInputs, formFieldName)

            formField.value = dataField
            nesProp.set(formInputs, formFieldName, formField)
        })

        return formInputs
    }

    /**
     * Save the form values by sending it to the server using the saveEmailServer API
     */
    save() {
        let {dispatch} = this.props
        let {fields} = this.state

        const data = this.fetchFormValues()
        fields = this.setFormInputsByFormValues(data, fields)
        let forceTouche = true
        fields = this.formInputsValidation(fields, forceTouche)
        let isValidTheForm = this.setFormValidityFlag()

        this.setState({fields: fields})

        // form validation can  prevent to step the wizard forward
        if (!isValidTheForm) {
            this.setState({isLoaded: true})
            return
        }

        console.log("saveEmailServer ", data)

        return dispatch(saveEmailServer(data))
        .then((newRecord) => {
            this.setState({configsLoaded: newRecord})
            this.setState({saved: true})
        })
    }

    /**
     * Delete a config set by _id fetched from state: "configsLoaded" and Reset the form
     */
    delete() {
        let {dispatch} = this.props
        let {fields, configsLoaded} = this.state

        let _id = nesProp.get(configsLoaded, "_id")

        if (!_id) {
            return
        }


        let keepEmailSelected = fields.emailAddress.value

        return dispatch(deleteEmailServer(_id))
        .then((newRecord) => {
            this.setState({configsLoaded: {}}, () => {
                this.resetForm()
                .then(()=>{
                    fields = this.setFormInputsByFormValues({"emailAddress": keepEmailSelected}, fields)
                    let forceTouche = false
                    fields = this.formInputsValidation(fields, forceTouche)
                    this.setState({fields: fields})
                    this.setState({isValidTheForm: true})
                    this.setState({isLoaded: true})
                    this.setState({saved: false})
                    this.unTouchFields()
                })
            })
        })
    }

    /**
     * Open test email modal
     *
     * @param {*} e
     */
    openTestMailModal(e) {
        this.setState({isOpenTestMailModal: true})
    }

    /**
     * Close test email modal
     */
    closeTestMailModal() {
        this.setState({isOpenTestMailModal: false})
    }

    /**
     * Open ask delete modal
     *
     * @param {*} e
     */
    openAreYouSureModal(e) {
        this.setState({isOpenAreYouSureModal: true})
    }

    /**
     * Close ask delete modal
     */
    closeAreYouSureModal() {
        this.setState({isOpenAreYouSureModal: false})
    }

    /**
     * This function will sent a test email to the given email address
     * @param {*} toEmailAddress
     * @returns {Promise} resolve when success, reject when error happen while sending the email.
     */
    sendTestEmail(toEmailAddress) {
        let {dispatch} = this.props
        let {fields} = this.state

        const data = this.fetchFormValues()
        fields = this.setFormInputsByFormValues(data, fields)
        let forceTouche = true
        fields = this.formInputsValidation(fields, forceTouche)
        let isValidTheForm = this.setFormValidityFlag()

        this.setState({fields: fields})

        // form validation can  prevent to step the wizard forward
        if (!isValidTheForm) {
            this.setState({isLoaded: true})
            return Promise.reject(_("noConfigurationToTest"))
        }

        // set the test recipient
        data["toEmailAddress"] = toEmailAddress

        return new Promise((resolve, reject) => {
            return this.setState({testEmailSent: false}, ()=> {
                dispatch(sendTestEmailWithConfig(data))
                .then((result) => {
                    this.setState({testEmailSent: result}, () => {
                        return resolve(result)
                    })
                    return result
                })
                .catch((error) => {
                    this.setState({onSendError: error}, ()=>{
                        reject(error)
                    })
                    return error
                })
            })
        })

    }

    /**
     * This function provide a reference to an icon on a safe way. If icon not found
     * return with a placeholder icon reference
     */
    getIcon = iconName => {
        try {
            return require(`resources/images/${iconName}`)
        }catch(err){
            return require(`resources/images/ic_do_not_disturb_black_24px.svg`)
        }
    }

    render() {
        const {isLoaded, fields, brokerOptions, isValidTheForm, saved, isOpenTestMailModal} = this.state
        const {configsLoaded, onSendError, isOpenAreYouSureModal} = this.state

        if (!isLoaded) {
            return (<div>Loading...</div>)
        }

        return (
            <div>
                <form
                    onSubmit={(e) => {e.preventDefault()}}
                    className={styles.formContent}
                >
                    <div className={styles.formInputContainer}>
                        <div className={styles.titleLabel}>
                            {_("descriptionForEmailServerConfig")}
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('emailAddress')}:*
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForEmailAddress")}
                                </span>
                            </div>
                        </label>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                            <CustomSelect
                                value={this.findItemByValueFromSelectOptions(fields.emailAddress.value, brokerOptions)}
                                ref="emailAddress"
                                name="emailAddress"
                                onChange={(value) => {
                                    let newEmailAddress = nesProp.get(value, "value")

                                    this.props.dispatch(loadEmailServer(newEmailAddress))
                                    .then((configsResult) => {
                                        this.setState({configsLoaded: configsResult}, () => {
                                            this.resetForm()
                                        })
                                    })
                                    .catch(() => {
                                        this.setState({configsLoaded: {}}, () => {
                                            this.resetForm()
                                        })
                                    })

                                    return this.onChangeFormInput(
                                        nesProp.get(value, "value") || "", "emailAddress"
                                    )
                                }}
                                handleOnBlur={(e) => {}}
                                options={brokerOptions}
                                isSearchable
                                isClearable
                                isMulti={false}
                                isCreatableSelect={false}
                            />
                        </div>
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.emailAddress.error && fields.emailAddress.touched &&
                                    fields.emailAddress.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('senderName')}:*
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForSenderName")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
                            type="text"
                            value={fields.senderName.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.value, "senderName")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.value, "senderName", forceTouch)
                            }}
                            ref="senderName"
                            name="senderName"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.senderName.error && fields.senderName.touched &&
                                    fields.senderName.error}
                            </div>
                        </div>
                    </div>
                    {/* <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('host')}:*
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForHost")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
                            type="text"
                            value={fields.host.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.value, "host")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.value, "host", forceTouch)
                            }}
                            ref="host"
                            name="host"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.host.error && fields.host.touched &&
                                    fields.host.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('port')}:*
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForPort")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
                            type="number"
                            value={fields.port.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.value, "port")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.value, "port", forceTouch)
                            }}
                            ref="port"
                            name="port"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.port.error && fields.port.touched &&
                                    fields.port.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('secureConnection')}:
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForSecureConnection")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
                            type="checkbox"
                            checked={fields.secureConnection.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.checked, "secureConnection")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.checked, "secureConnection", forceTouch)
                            }}
                            ref="secureConnection"
                            name="secureConnection"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.secureConnection.error && fields.secureConnection.touched &&
                                    fields.secureConnection.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('secure')}:
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForSecure")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
                            type="checkbox"
                            checked={fields.secure.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.checked, "secure")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.checked, "secure", forceTouch)
                            }}
                            ref="secure"
                            name="secure"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.secure.error && fields.secure.touched &&
                                    fields.secure.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('autotls')}:
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForAutotls")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
                            type="checkbox"
                            checked={(!!(fields.autotls.value))}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.checked, "autotls")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.checked, "autotls", forceTouch)
                            }}
                            ref="autotls"
                            name="autotls"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.autotls.error && fields.autotls.touched &&
                                    fields.autotls.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('tls_rejectUnauthorized')}:
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForTlsRejectUnauthorized")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
                            type="checkbox"
                            checked={fields.tls_rejectUnauthorized.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.checked, "tls_rejectUnauthorized")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.checked, "tls_rejectUnauthorized", forceTouch)
                            }}
                            ref="tls_rejectUnauthorized"
                            name="tls_rejectUnauthorized"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.tls_rejectUnauthorized.error && fields.tls_rejectUnauthorized.touched &&
                                    fields.tls_rejectUnauthorized.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('auth_user')}:*
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForAuthUser")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
                            type="text"
                            value={fields.auth_user.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.value, "auth_user")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.value, "auth_user", forceTouch)
                            }}
                            ref="auth_user"
                            name="auth_user"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.auth_user.error && fields.auth_user.touched &&
                                    fields.auth_user.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('auth_password')}:*
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForAuthPassword")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
                            type="password"
                            value={fields.auth_password.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.value, "auth_password")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.value, "auth_password", forceTouch)
                            }}
                            ref="auth_password"
                            name="auth_password"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.auth_password.error && fields.auth_password.touched &&
                                    fields.auth_password.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('service')}:
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForService")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
                            type="text"
                            value={fields.service.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.value, "service")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.value, "service", forceTouch)
                            }}
                            ref="service"
                            name="service"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.service.error && fields.service.touched &&
                                    fields.service.error}
                            </div>
                        </div>
                    </div>

                    {/* <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('useBounce')}:
                                <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                    <img src={this.getIcon('a-info_1x.png')}/>
                                    <span className={cs(styles.tooltiptext, styles.w600)}>
                                        {_("toolTipForUseBounce")}
                                    </span>
                                </div>
                        </label>
                        <input
                            className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
                            type="checkbox"
                            checked={fields.useBounce.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.checked, "useBounce")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.checked, "useBounce", forceTouch)
                            }}
                            ref="useBounce"
                            name="useBounce"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.useBounce.error && fields.useBounce.touched &&
                                    fields.useBounce.error}
                            </div>
                        </div>
                    </div>

                    <div className={styles.formInputContainer}>
                        <label className={styles.formLabel}>{_('active')}:
                            <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
                                <img src={this.getIcon('a-info_1x.png')}/>
                                <span className={cs(styles.tooltiptext, styles.w600)}>
                                    {_("toolTipForActive")}
                                </span>
                            </div>
                        </label>
                        <input
                            className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
                            type="checkbox"
                            checked={fields.active.value}
                            onChange={(e) => {
                                return this.onChangeFormInput(e.target.checked, "active")
                            }}
                            onBlur={(e) => {
                                let forceTouch = true
                                return this.onChangeFormInput(e.target.checked, "active", forceTouch)
                            }}
                            ref="active"
                            name="active"
                        />
                        <div>
                            <div className={styles.errorMessage}>
                                {fields.active.error && fields.active.touched &&
                                    fields.active.error}
                            </div>
                        </div>
                    </div> */}
                    {saved &&
                    <div className={styles.saveNotification}>
                        {_('brokerEmailConfigurationsUpdatedFor') + " " + fields.emailAddress.value +
                            " - " + moment(nesProp.get(configsLoaded, "updatedAt")).format("YYY/MM/DD HH:mm:ss.")}
                        <span className={styles.saveNotificationSmall}>
                            {moment(nesProp.get(configsLoaded, "updatedAt")).format("SS")}
                        </span>
                    </div>}
                    <div className={styles.buttonContainer}>

                        <button
                            type="button"
                            className={cs(styles.greyButton, ((!nesProp.get(configsLoaded, "_id")) ? "disabled" : "enabled"), styles.buttonSizeM)}
                            onClick={(e)=>{ this.openAreYouSureModal(e) }}
                            disabled={!nesProp.get(configsLoaded, "_id")}
                        >
                            {_("deleteConfigs")}
                        </button>
                        {/* <button
                            type="button"
                            className={cs(styles.greyButton, ((!isValidTheForm) ? "disabled" : "enabled"), styles.buttonSizeM)}
                            onClick={(e)=>{ this.openTestMailModal(e) }}
                            disabled={!fields.emailAddress.value}
                        >
                            {_("sendTestEmail")}
                        </button> */}
                        <button
                            type="button"
                            className={styles.greyButton + ((!isValidTheForm) ? " disabled" : " enabled")}
                            onClick={(e)=>{ this.save(e) }}
                            disabled={!fields.emailAddress.value}
                        >
                            {_("save")}
                        </button>
                    </div>

                </form>
                <TestEmailDialog
                    modalIsOpen={isOpenTestMailModal}
                    cancelLabel={_("cancel")}
                    confirmationLabel={_("send")}
                    finishLabel={_("finish")}
                    onCancel={()=>{
                        this.setState({onSendError: null})
                        this.closeTestMailModal()
                    }}
                    onConfirmation={(toEmailAddress)=>{
                        return this.sendTestEmail(toEmailAddress)
                        .then((result) => {
                            this.setState({onSendError: true})
                        })
                        .catch((onSendErrorResult) => {
                            console.log("Target place onSendErrorResult: ", onSendErrorResult)
                            this.setState({onSendError: onSendErrorResult})
                        })
                    }}
                    onFinish={()=>{
                            this.setState({onSendError: null})
                            this.closeTestMailModal()
                    }}
                    onSendResultMessage={onSendError}
                />
                <AreYouSureDialog
                    modalIsOpen={isOpenAreYouSureModal}
                    title={_("emailSettingsAreYouSureModalTitle")}
                    message={_("emailSettingsAreYouSureModalMessage")}
                    cancelLabel={_("cancel")}
                    confirmationLabel={_("delete")}
                    onCancel={()=>{
                        this.closeAreYouSureModal()
                    }}
                    onConfirmation={(toEmailAddress)=>{
                        return this.delete()
                        .then(() => {
                            this.closeAreYouSureModal()
                        })
                    }}
                />

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/office/emailSetup.jsx